window.Video = function () {
  return {
    init() {
      if (!this.shouldPlay()) return

      const el = this.$el
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return
          observer.disconnect()
          el.play()
        },
        { rootMargin: '200px' }
      )
      observer.observe(el)
    },

    shouldPlay() {
      const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
      if (mediaQuery.matches) {
        this.$el.removeAttribute('autoplay')
        return false
      }
      return true
    },
  }
}
